import { render, staticRenderFns } from "./InputRichText.vue?vue&type=template&id=49b3bace&"
import script from "./InputRichText.vue?vue&type=script&lang=js&"
export * from "./InputRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports